import React, { FC } from 'react';
import { GridSize } from '@mui/material/Grid/Grid';
import { SystemProps } from '@mui/system/Box';
import { Breakpoint } from '@mui/material/styles';
import { Grid } from '@mui/material';
import cssVariables from '../../../../variables.module.scss';

type ResponsiveStyleValue<T> = T | Array<T | null> | { [key in Breakpoint]?: T | null };

interface ContentSectionProps {
    children: React.ReactNode;
    // eslint-disable-next-line react/require-default-props
    size?: ResponsiveStyleValue<GridSize>;
    // eslint-disable-next-line react/require-default-props
    className?: string;
    // eslint-disable-next-line react/require-default-props
    sx?: SystemProps<{}>;
    // eslint-disable-next-line react/require-default-props
    ref?: React.RefObject<HTMLDivElement> | undefined;
    // eslint-disable-next-line react/require-default-props
    id?: string;
}

const ContentSection: FC<ContentSectionProps> = (props) => {
    const { children, size, className, sx, ref, id } = props;
    return (
        <Grid
            data-testid="ContentSection"
            spacing={cssVariables.gapContentSection}
            container
            size={size ?? undefined}
            className={className ?? undefined}
            sx={{
                alignContent: 'flex-start',
                ...sx,
            }}
            ref={ref ?? undefined}
            id={id ?? undefined}
        >
            {children}
        </Grid>
    );
};

export default ContentSection;
